import type { SceneNode } from '@aod/protocol';
import { useCallback } from 'react';
import type { SimWorld } from './sim/useSimWorld/index.js';

const DIRS = [
  [1, 0] as const,
  [1, -1] as const,
  [0, -1] as const,
  [-1, 0] as const,
  [-1, 1] as const,
  [0, 1] as const,
];

export function useDeployGarrison(sim: SimWorld, localPlayerIndex: number) {
  return useCallback(
    (cityId: string) => {
      if (!sim.snapshot) return;
      const all = sim.snapshot.scene.children ?? [];
      const city = all.find((n) => n.id === cityId);
      if (!city) return;
      const cq = city.props?.q as number | undefined;
      const cr = city.props?.r as number | undefined;
      if (cq === undefined || cr === undefined) return;

      const garrisoned = all.find((n) => {
        if (n.type !== 'unit') return false;
        return (
          (n.props?.ownerId as number | undefined) === localPlayerIndex &&
          (n.props?.q as number | undefined) === cq &&
          (n.props?.r as number | undefined) === cr
        );
      });
      if (!garrisoned) return;

      for (const [dq, dr] of DIRS) {
        const tq = cq + dq;
        const tr = cr + dr;
        const blocked = all.some(
          (n) =>
            (n.type === 'city' || n.type === 'unit') &&
            (n.props?.q as number | undefined) === tq &&
            (n.props?.r as number | undefined) === tr,
        );
        if (!blocked) {
          sim.deployUnit(garrisoned.id, tq, tr);
          return;
        }
      }
    },
    [sim, localPlayerIndex],
  );
}
